import { QueryObserverOptions, useQuery } from "react-query";
import { APIError, APIResponse, API_URL, get } from "../api";
import { BookedFlight } from "../@types";

function useFlightBookings(
  options?: QueryObserverOptions<APIResponse<BookedFlight[]>, APIError>
) {
  const {
    isLoading: fetchingFlightBookings,
    isError: isFlightBookingsError,
    data: flightBookingsData,
    refetch: refreshFlightBookings,
    isFetching: isRefetchingFlightBookings,
  } = useQuery<APIResponse<BookedFlight[]>, APIError>(
    "flight-bookings-dashboard",
    async () =>
      await get(`${API_URL}/account/booked-flights/flights`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }),
    { refetchOnWindowFocus: true, ...options }
  );

  const allFlights = flightBookingsData?.data ?? [];
  const bookedFlights = allFlights.filter((f) => f.status === "TicketIssued");
  const pendingFlights = allFlights.filter((f) => f.status !== "TicketIssued");

  return {
    fetchingFlightBookings,
    isFlightBookingsError,
    flightBookingsData,
    refreshFlightBookings,
    isRefetchingFlightBookings,
    bookedFlights,
    pendingFlights,
  };
}

export default useFlightBookings;
